var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content__frame mb-70 p-24" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-4" }, [
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c("label", { staticClass: "form__label" }, [_vm._v("Company name")]),
          _c("input", {
            staticClass: "form__control",
            class: {
              "error-controls": !!_vm.errors && !!_vm.errors.companyNameError,
              "disable-color-input": _vm.readonlyMode
            },
            attrs: {
              id: "company-name-input",
              name: "company-name-input",
              type: "text",
              placeholder: "Please input company name",
              maxlength: "200",
              disabled: _vm.readonlyMode
            },
            domProps: { value: _vm.companyName },
            on: {
              blur: _vm.handleCompanyNameBlur,
              input: _vm.handleCompanyNameInput
            }
          }),
          _c("label", { staticClass: "form__valid mb-0 mt-8" }, [
            _vm._v("Max length 200 characters")
          ]),
          !!_vm.errors && !!_vm.errors.companyNameError
            ? _c(
                "span",
                {
                  staticClass:
                    "content__feedback content__feedback__payerinformation",
                  attrs: { "data-testid": "company-name-error" }
                },
                [_vm._v(" " + _vm._s(_vm.errors.companyNameError) + " ")]
              )
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "col-lg-4 mb-768-16" }, [
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c("label", { staticClass: "form__label" }, [
            _vm._v("Email address")
          ]),
          _c("input", {
            staticClass: "form__control",
            class: {
              "error-controls": !!_vm.errors && !!_vm.errors.emailError,
              "disable-color-input": _vm.readonlyMode
            },
            attrs: {
              id: "email-input",
              name: "email-input",
              type: "text",
              placeholder: _vm.getTextByCountryCode(
                _vm.countryCode,
                "component_payerInformation_emailTextBox_placeHolder"
              ),
              maxlength: "200",
              disabled: _vm.readonlyMode
            },
            domProps: { value: _vm.email },
            on: { blur: _vm.handleEmailBlur, input: _vm.handleEmailInput }
          }),
          _c("label", { staticClass: "form__valid mb-0 mt-8" }, [
            _vm._v("Ex: aaa@aaaaa.com")
          ]),
          !!_vm.errors && !!_vm.errors.emailError
            ? _c(
                "span",
                {
                  staticClass:
                    "content__feedback content__feedback__payerinformation",
                  attrs: { "data-testid": "email-error" }
                },
                [_vm._v(" " + _vm._s(_vm.errors.emailError) + " ")]
              )
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "col-lg-4" }, [
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c("label", { staticClass: "form__label" }, [
            _vm._v("Contact number")
          ]),
          _c(
            "div",
            {
              staticClass: "input-group",
              class: {
                "error-controls":
                  !!_vm.errors && !!_vm.errors.contactNumberError
              },
              attrs: { "data-testid": "contact-number-group" }
            },
            [
              _c(
                "div",
                { staticClass: "input-group-prepend" },
                [
                  _c("EpDropdown", {
                    attrs: {
                      selectedItem: _vm.contactInfo,
                      items: _vm.supportedAreaCodes,
                      disabled: _vm.readonlyMode,
                      itemKey: "countryCode"
                    },
                    on: {
                      "update:selectedItem": _vm.handleUpdateContactNumber
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selectedItem",
                        fn: function(ref) {
                          var selectedItem = ref.selectedItem
                          return [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn form__phone d-flex justify-content-between align-items-center txt-black pl-16 pr-16 position-relative h-100",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.readonlyMode
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "mr-8 area-code",
                                  attrs: {
                                    src: selectedItem.urlImage,
                                    alt: "flag-icon",
                                    width: "32"
                                  }
                                }),
                                _vm._v(
                                  " " + _vm._s(selectedItem.countryCode) + " "
                                ),
                                _c("img", {
                                  staticClass: "img-24 ml-8",
                                  attrs: {
                                    src: require("@static/img/dropdown.svg"),
                                    alt: "dropdown"
                                  }
                                })
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "item",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("img", {
                              staticClass: "mr-16 area-code",
                              attrs: {
                                src: item.urlImage,
                                alt: item.countryName,
                                width: "32"
                              }
                            }),
                            _c("span", { staticClass: "mr-2" }, [
                              _vm._v(_vm._s(item.countryName))
                            ]),
                            _c("span", [_vm._v(_vm._s(item.countryCode))])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("input", {
                staticClass: "form__control contact-no",
                class: {
                  "error-controls-only-background":
                    !!_vm.errors && !!_vm.errors.contactNumberError,
                  "disable-color-input": _vm.readonlyMode
                },
                attrs: {
                  id: "contact-number-input",
                  name: "contact-number-input",
                  type: "tel",
                  "aria-label": "Text input with dropdown button",
                  placeholder: "Please input your contact number",
                  maxlength: "12",
                  disabled: _vm.readonlyMode
                },
                domProps: { value: _vm.contactNumber },
                on: {
                  blur: _vm.handleContactNumberBlur,
                  keypress: _vm.handleContactNumberKeypress,
                  input: _vm.handleContactNumberInput
                }
              })
            ]
          ),
          _c("label", { staticClass: "form__valid mb-0 mt-8" }, [
            _vm._v("Max length 12 digits")
          ]),
          !!_vm.errors && !!_vm.errors.contactNumberError
            ? _c(
                "span",
                {
                  staticClass: "content__feedback",
                  attrs: { "data-testid": "contact-number-error" }
                },
                [_vm._v(" " + _vm._s(_vm.errors.contactNumberError) + " ")]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }